/*
*
* Public functions
*
*/

// Given a singular index return the exercise
export const GetCurrentExercise = (workout, singularIndex) => {
    var dualIndices = ConvertSingularIndexToDualIndices(workout, singularIndex);
    return workout.exercises[dualIndices.exerciseIndex];
}

// Given a singular index return the exercise set
export const GetCurrentSet = (workout, singularIndex) => {
    var dualIndices = ConvertSingularIndexToDualIndices(workout, singularIndex);
    return workout.exercises[dualIndices.exerciseIndex].sets[dualIndices.setIndex];
}

// Returns true if we are on the final set of a workout, returns false if not
export const OnFinalSetOfTheWorkout = (workout, singularIndex) => {
    var totalSetCount = CalculateTotalSetsInTheWorkout(workout);
    if (singularIndex == (totalSetCount - 1)) return true
    else return false
}

// Converts singular index to dual indices
export const ConvertSingularIndexToDualIndices = (workout, singularIndex) => {

    // Loop through all exercises
    for (let i = 0; i < workout.exercises.length; i++) {
        
        // console.log("Singular Index: " + singularIndex);

        // If the exercise index is greater than the length of the sets, we need to move onto the next exercise
        if (workout.exercises[i].sets.length - 1 < singularIndex){
            singularIndex = singularIndex - (workout.exercises[i].sets.length)
        }
        // Once we hit the exercise that has a set available for the given singular index remainder, return the dual indices
        else {
            var result = { "exerciseIndex": i, "setIndex": singularIndex }
            // console.log(result);
            return result;
        }

    }

}

// Converts dual indices to a singular index
export const ConvertDualIndicesToSingularIndex = (workout, exerciseIndex, setIndex) => {
    var previousSetLengthsSum = 0;
    for (let i = 0; i < exerciseIndex; i++) {
        previousSetLengthsSum += workout.exercises[i].sets.length;
    }
    return (previousSetLengthsSum + setIndex);
}

// Check if the workout set we are currently viewing is the workout set that is next up in the sequnce
export const CheckIfOnCurrentSetOfTheWorkout = (workout, singularIndex) => {
    
    var totalSetCount = CalculateTotalSetsInTheWorkout(workout);
    var dualIndices = ConvertSingularIndexToDualIndices(workout, singularIndex);

    // Loop all singular indices
    for (let i = 0; i < totalSetCount; i++) {
            
        // Covert each singular indice to dual indice
        var tempDualIndices = ConvertSingularIndexToDualIndices(workout, i);
        
        // On the first incomplete exercise set found
        if(!workout.exercises[tempDualIndices.exerciseIndex].sets[tempDualIndices.setIndex].completed){
            
            // Set the hook to see if we are on said incomplete exercise
            return (tempDualIndices.exerciseIndex === dualIndices.exerciseIndex && tempDualIndices.setIndex === dualIndices.setIndex);
        }   
    }
    
    // If all exercises are completed this should matter but we can set it to length
    // setOnNextIncompleteExercise(workout.exercises.length);

}

export const GetSingularIndexCurrentSetOfTheWorkout = (workout) => {

    var totalSetCount = CalculateTotalSetsInTheWorkout(workout);

    // Loop all singular indices
    for (let i = 0; i < totalSetCount; i++) {
            
        // Covert each singular indice to dual indice
        var tempDualIndices = ConvertSingularIndexToDualIndices(workout, i);
        
        // On the first incomplete exercise set found
        if(!workout.exercises[tempDualIndices.exerciseIndex].sets[tempDualIndices.setIndex].completed) return i;

    }

    // If we do not navigate at this point go to the final exercise
    return (totalSetCount - 1)

}

/*
*
* Private functions
*
*/

const CalculateTotalSetsInTheWorkout = (workout) => {

    if (workout.exercises !== null || workout.exercises !== undefined || workout.exercises.length !== undefined){

        var result = 0;
        
        for (let i = 0; i < workout.exercises.length; i++) 
        {
            if (workout.exercises[i].sets !== undefined){ 
                result += workout.exercises[i].sets.length; 
            }
        }
        // console.log("Workout Set Count: " + result);
        return result;
    }
}

// Same as the athlete app (functions/workoutUtils.js): the slots of a workout trained at a selected workout length
export const FilterWorkoutByWorkoutLength = (workout, workoutLength) => {

    // Slots without length data are kept so missing data never hides an exercise
    const IsSlotSupported = (slot) => {
        const supportedWorkoutLengths = slot.supportedWorkoutLengthsJSON
        if (!Array.isArray(supportedWorkoutLengths) || supportedWorkoutLengths.length === 0) return true
        return supportedWorkoutLengths.includes(workoutLength)
    }

    const phases = workout.phases
        .map((phase) => ({ ...phase, slots: phase.slots.filter(IsSlotSupported) }))
        .filter((phase) => phase.slots.length > 0)

    return { ...workout, phases }

}

// Swaps made when the workout was generated (a duplicate exercise core swap or a coach one-off override, see the backend's
// WorkoutUtils.NON_PROGRESSING_SWAP_REASON_KEYS). They can't be undone while running a workout: the slot's exercise counts as the original
const GENERATED_SWAP_REASON_KEYS = ['duplicate-exercise-core-auto-swap', 'coach-one-off-override']

// Reason key saved on the slot (exerciseSwapReasonKey) for a swap the coach makes while running a workout (preview or active workout)
export const COACH_ACTIVE_WORKOUT_SWAP_REASON_KEY = 'coach-active-workout-swap'

// Same as the athlete app's IsAthleteSwappedSlot: swapped while running the workout, so it can be undone
export const IsActiveWorkoutSwappedSlot = (slot) => {
    return slot?.originalExerciseId != null && GENERATED_SWAP_REASON_KEYS.includes(slot?.exerciseSwapReasonKey) === false
}

// Mutates the slot. A swap on top of a generated swap keeps the collection's exercise as originalExerciseId (what the backend saves)
// and remembers the generated swap in generatedSwap, so undoing goes back to it
export const SwapSlotExercise = (slot, exerciseId, exerciseSwapReasonKey = COACH_ACTIVE_WORKOUT_SWAP_REASON_KEY) => {
    // Picking the slot's current exercise is not a swap (it would be saved as one and skip the collection's progression)
    if (exerciseId === slot.exerciseId) return

    if (slot.originalExerciseId != null && GENERATED_SWAP_REASON_KEYS.includes(slot.exerciseSwapReasonKey)) {
        slot.generatedSwap = {
            exerciseId: slot.exerciseId,
            originalExerciseId: slot.originalExerciseId,
            exerciseSwapReasonKey: slot.exerciseSwapReasonKey
        }
    }

    if (slot.originalExerciseId == null) slot.originalExerciseId = slot.exerciseId

    slot.exerciseId = exerciseId
    slot.exerciseSwapReasonKey = exerciseSwapReasonKey
}

// Mutates the slot. Undoes the running workout swap only (back to the generated swap, if the swap was on top of one)
export const UndoSlotExerciseSwap = (slot) => {
    if (IsActiveWorkoutSwappedSlot(slot) === false) return

    const generatedSwap = slot.generatedSwap ?? null

    slot.exerciseId = generatedSwap?.exerciseId ?? slot.originalExerciseId
    slot.originalExerciseId = generatedSwap?.originalExerciseId ?? null
    slot.exerciseSwapReasonKey = generatedSwap?.exerciseSwapReasonKey ?? ''

    delete slot.generatedSwap
}

// A group workout is saved once for the group and once for each group individual. Once a group individual's copy is started or completed it
// is set in stone, so the workout can no longer be moved to another day (backend WorkoutUtils.IsGroupWorkoutLocked).
// groupIndividualWorkouts: the group individuals' workouts (calendar items) of the group workout's day
export const IsGroupWorkoutLocked = (groupWorkout, groupIndividualWorkouts = []) => {
    const IsStartedOrCompleted = (workout) => workout?.started === 1 || workout?.completed === 1
    const VariantKey = (workout) => (workout?.workoutVariantLetter || '').toUpperCase() || workout?.name

    return groupIndividualWorkouts.some((workout) => (
        workout.workoutConfigId === groupWorkout?.workoutConfigId
        && VariantKey(workout) === VariantKey(groupWorkout)
        && IsStartedOrCompleted(workout)
    ))
}
